import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid-x grid-padding-x" }
const _hoisted_2 = { class: "large-12 medium-12 cell" }
const _hoisted_3 = { style: {"font-weight":"normal"} }
const _hoisted_4 = { class: "grid-container" }
const _hoisted_5 = { class: "grid-x grid-padding-x message" }
const _hoisted_6 = { class: "large-9 medium-9 small-9 cell" }
const _hoisted_7 = {
  class: "h4",
  style: {"padding-top":"2vh"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, { id: "confirmationMessage" }, {
    "modal-header": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.titleFirstWord), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.titleFormatted), 1)
          ])
        ])
      ])
    ]),
    "modal-body": _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "large-3 medium-3 small-3 cell" }, [
            _createElementVNode("i", { class: "bi bi-check-circle-fill" })
          ], -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('messages.modals.confirmation.message')), 1)
          ])
        ])
      ])
    ]),
    "modal-footer": _withCtx(() => [
      _createElementVNode("button", {
        class: "button call-to-action large expanded",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uiOptions().toggleModal('confirmationMessage')))
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1)),
        _createTextVNode(_toDisplayString(_ctx.$t('messages.modals.confirmation.close')), 1)
      ])
    ]),
    _: 1
  }))
}